import React from 'react';
import { connect } from 'react-redux';
import { Link } from '@zola/zola-ui';

import { showModal } from 'actions/ModalActions';
import { addEntity } from 'actions/website/EntityActions';

import { trackEditRegistryClick } from '../util/tracking';

const AddARegistryLink = ({ openModal, trackingPayload, ...props }) => {
  return (
    <Link
      {...props}
      arrow
      onClick={() => {
        openModal();
        if (trackingPayload) trackEditRegistryClick(trackingPayload);
      }}
    >
      Add A Registry Link
    </Link>
  );
};

const mapDispatchToProps = dispatch => ({
  openModal: () => {
    dispatch(addEntity());
    dispatch(showModal('REGISTRY', {}, { size: 'md' }));
  },
});

export default connect(null, mapDispatchToProps)(AddARegistryLink);



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/components/AddARegistryLink.jsx